import verticalItems from '../vertical';

// The top menu (used when someone picks "Menu on top" in the user menu) shows the same items as the side menu,
// so there is one list to maintain: navigation/vertical/index.js.
// The top menu shows an item with sub-items as a dropdown, which it labels from `header`.
export default verticalItems.map((item) => (item.children
  ? { ...item, header: item.title, children: item.children.map((child) => ({ ...child })) }
  : { ...item }));
